






import { Component, Prop, Vue } from "vue-property-decorator";
import BrowserButtonType from "@/enums/BrowserButtonType.ts";

@Component
export default class BrowserButton extends Vue {
  @Prop() private type!: BrowserButtonType;
  @Prop() private onClick?: () => void;

  private handleClickButton = (e: MouseEvent) => {
    if (this.onClick) {
      this.onClick();
    }
  };
}
